import { useTheme, jsx, Global, css } from '@emotion/react';
import React, { useMemo } from 'react';
import { css as css$1, sxProp } from '@indeed/ifl-css';
import { createColorProperties } from '../IndeedThemeProvider/utils.js';

const html = {
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  "*, *::before, *::after": {
    boxSizing: "inherit"
  }
};
const body = {
  "@media print": {
    // Save printer ink.
    backgroundColor: "white"
  },
  // Add support for document.body.requestFullScreen().
  // Other elements, if background transparent, are not supported.
  "&::backdrop": {
    backgroundColor: "background"
  }
};
const baseStyles = props => css$1({
  html,
  body,
  // apply root styles to the html and body
  "html, body": {
    variant: "styles.root"
  },
  // apply element styles from theme
  variant: "styles"
})(props.theme);

/**
 * @see https://experience.indeed.design/components/ids/global-styles
 */
const GlobalStyles = props => {
  const theme = useTheme();
  const properties = useMemo(() => {
    return createColorProperties(theme.rawColors || {}, "colors");
  }, [theme]);
  return jsx(React.Fragment, null, jsx(Global, {
    styles: /*#__PURE__*/css({
      ":root": properties
    }, process.env.NODE_ENV === "production" ? "" : ";label:GlobalStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }), jsx(Global, {
    styles: baseStyles({
      ...props,
      theme
    })
  }), props.sx ? jsx(Global, {
    styles: sxProp({
      ...props,
      theme
    })
  }) : null);
};
GlobalStyles.displayName = "GlobalStyles";

export { GlobalStyles, body, html };
